export const RouterConfig = {
  root: "/",
  happyCoding: "happy-coding",
};
